import { createStore } from 'vuex'
import { auth } from "./auth.module";
import { option } from "./option.module";
export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    option
  }
})
